// third party imports
import React, { useContext } from "react";

// internal rebet imports
import "./stylesPlayers.css";
import { SIDER_TABS } from "../../utils/Constants";

// component imports
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import Layout from "../CommonComponents/Layout/Layout";
import UserCard from "./UserCard/UserCard";
import DashboardLineChart from "./DashboardLineChart/DashboardLineChart";
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import SportPerformanceTable from "./SportPerformanceTable/SportPerformanceTable";
import AppContext from "../../context/AppContext";

// asset imports

const Players = () => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );
  const { setActiveSidebarTab } = useContext(AppContext);
  setActiveSidebarTab(SIDER_TABS.PLAYERS);


  const kpis = {
    labels: [
      "Aug 20",
      "Sep 20",
      "Oct 20",
      "Nov 20",
      "Dec 20",
      "Jan 21",
      "Feb 21",
      "Mar 21",
    ],
    datasets: [
      {
        label: "Balance",
        data: [20000, 25000, 30000, 40000, 32000, 31000, 28000, 24000],
        borderColor: "#F39C12",
        backgroundColor: "#F39C12",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
    headers: [
      { title: "Total Rebet CASH balance", amount: 24000, percentage: 7 },
      { title: "Non-wagered Rebet CASH", amount: 3500, percentage: -5 },
      { title: "Redeemable Rebet CASH", amount: 18900, percentage: 10 },
    ],
  };

  const topBar = [
    "Personal Info",
    "Sportsbook",
    "Casino",
    "Finance",
    "Compliance",
    "Referral Program",
    "Support",
  ];

  return (
    <Layout selectedTab={SIDER_TABS?.PLAYERS}>
      <div className="players-container">
        <h2>Back to Players list</h2>
        <div className="players-body">
          <UserCard />
          <div className="players-right-content">
            <div className="players-top-bar">
              {topBar.map((item, index) => (
                <div key={index} className={`players-top-bar-item ${index === 0 ? "active" : ""}`}>
                  {item}
                </div>
              ))}
            </div>
            <DashboardLineChart data={kpis} headers={kpis.headers} />
            <PersonalInfo />
            <SportPerformanceTable />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Players;
